export default "__VITE_ASSET__uYRF6lAV__"